
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
const HOST = `${config.API_HOST}`
/* ['APIView'] */
/* params: 'code' */
/* data:  */
const CostCenterIncomePerReceipt : 
{
  get: ({params, apiToken, extra}:
             {  
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  post:   ({params, data, apiToken, extra}:
            { 
            params?: any,
            data?: any,
            apiToken?: any,
            extra?: any
        }) => any,
  put:   ({params, data, apiToken, extra}:
             { 
                params?: any,
                data?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  patch:    ({params, data, apiToken, extra}:
             { 
                params?: any,
                data?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  get: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/INF/cost-center-income-per-receipt/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  post: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.post(`${HOST}/apis/INF/cost-center-income-per-receipt/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  put: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.put(`${HOST}/apis/INF/cost-center-income-per-receipt/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  patch: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.patch(`${HOST}/apis/INF/cost-center-income-per-receipt/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default CostCenterIncomePerReceipt

